import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H3 } from 'components/core/Headline';
import { Text } from 'components/core/Text';
import { UnitIcon } from 'components/unit/UnitIcon';

import './vehicleUnitSizeGuide.scss';

/* eslint-disable max-len */
const UNIT_SIZES = [
	{
		display: '15\' Long',
		bucket: '10x15',
		description: 'Most coupes, hatchbacks, crossovers and small SUVs that come under 15 feet in length will fit. If you choose this size, you might be left with only a few inches of space.'
	}, {
		display: '20\' Long',
		bucket: '10x20',
		description: 'Most cars will fit comfortably, including SUVs, crossovers, sedans, minivans, pickup trucks and most full-sized vans.'
	}, {
		display: '25\' Long',
		bucket: '10x25',
		description: 'Perfect for larger vehicles or a boat. Small Class B campers, small Class C campers, travel trailers, toy trailers and pop-ups may also fit in spaces designed for RV storage.'
	}, {
		display: '30\' Long',
		bucket: '10x30',
		description: 'Store one or multiple vehicles with plenty of other possessions, including furniture and large appliances. This size can also handle smaller-to-medium sized Class B campers and travel trailers, large pop-ups, and smaller Class C campers and fifth-wheel trailers.'
	}, {
		display: '35\' Long',
		bucket: '10x35',
		description: 'Store one or multiple vehicles with plenty of other possessions, including furniture and large appliances. This size can typically contain large Class B and Class C campers, mid-to-large sized travel trailers, small-to-mid sized fifth-wheel campers, large toy trailers, and small Class A campers.'
	}, {
		display: '40\' Long',
		bucket: '10x40',
		description: 'All but the largest of RVs will fit into a 40\' storage space. This includes most Class A campers, large travel trailers and fifth-wheel trailers. Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet.'
	}, {
		display: '50\' Long',
		bucket: '10x50',
		description: '50\' RV storage space will handle the largest of RVs, like large Class A campers, travel trailers and destination trailers. Remember that with the added length often comes additional width and height, meaning that many of these extra-large vehicles will require ceilings with a minimum height of 15 feet.'
	}
];
/* eslint-enable */

export default function VehicleUnitSizeGuide({ className }) {
	return (
		<div className={classnames(className, 'vehicle-unit-size-guide')}>
			<H3 size="medium" strong>Unit size guide</H3>
			<div className="unit-sizes">
				{UNIT_SIZES.map((unit) => (
					<div className="unit-size" key={unit.bucket}>
						<div className="unit-icon-container">
							<UnitIcon unitSize={`${unit.bucket}-parking_space`} />
						</div>
						<div className="unit-description">
							<Text size="tiny">
								{unit.description}
							</Text>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

VehicleUnitSizeGuide.propTypes = {
	className: PropTypes.string
};
